import { useSyncExternalStore } from 'react';

/**
 * **Le sfide di piattaforma con un tocco IN VOLO (Accetta o Rifiuta partito, risposta non ancora arrivata),
 * per QUESTA pagina** — uno store di MODULO come `sfideGestite`, e per la stessa ragione: la stessa sfida ha
 * piu' di una superficie (la barra, che su `/friends` la mostra perche' la riga non ha destinazione, e il tab
 * «Sfide» di Amici), e una guardia per ISTANZA non si vedono fra loro: dopo Accetta nella barra, un secondo
 * tocco nel tab mandava una seconda POST (misurato dalla prima passata di revisione di B2).
 * `prendiSfidaInVolo` e' SINCRONA e atomica (controlla e inserisce): due tocchi nello stesso batch, anche da
 * due superfici, ne vedono passare uno solo. Non sostituisce `sfideGestite` (quella dice «ci ho gia' agito»,
 * questa «sto agendo adesso»): la guardia dura quanto la richiesta.
 */
let inVolo: ReadonlySet<string> = new Set();
const ascoltatori = new Set<() => void>();
const avvisa = () => ascoltatori.forEach((f) => f());

/** `true` se il tocco puo' partire (nessun altro in volo su questa sfida), e da qui la segna in volo. */
export function prendiSfidaInVolo(challengeId: string): boolean {
  if (inVolo.has(challengeId)) return false;
  // Un Set NUOVO a ogni cambio: `useSyncExternalStore` confronta per riferimento.
  inVolo = new Set(inVolo).add(challengeId);
  avvisa();
  return true;
}

export function rilasciaSfidaInVolo(challengeId: string): void {
  if (!inVolo.has(challengeId)) return;
  const resto = new Set(inVolo);
  resto.delete(challengeId);
  inVolo = resto;
  avvisa();
}

export const staSfidaInVolo = (challengeId: string): boolean => inVolo.has(challengeId);

const leggi = () => inVolo;
const iscrivi = (f: () => void) => {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
};

/** Gli id in volo, con re-render a ogni cambio: le superfici spengono i pulsanti anche per un tocco dell'ALTRA. */
export function useSfideInVolo(): ReadonlySet<string> {
  return useSyncExternalStore(iscrivi, leggi, leggi);
}

/** Solo per i test: un file di test non deve ereditare le sfide in volo del precedente. */
export function azzeraSfideInVoloPerTest(): void {
  inVolo = new Set();
  avvisa();
}
